import { Component, OnInit } from '@angular/core';

interface Contato {
  id: number;
  nome: string;
  email: string;
  mensagem: string;
  dataCriacao: string;
  lido: boolean;
}

@Component({
  selector: 'app-contato',
  templateUrl: './contato.component.html',
  styleUrls: ['./contato.component.scss']
})
export class ContatoComponent implements OnInit {

  contatos: Contato[] = [];
  filtroNome: string = '';
  filtroTipo: string = '';
  filtroStatus: string = '';
  exibirFormulario: boolean = false;
  contatoEditando: Contato | null = null;

  formData = {
    nome: '',
    email: '',
    mensagem: ''
  };



  constructor() { }

  ngOnInit(): void {
    this.carregarContatos();
  }

  carregarContatos(): void {
    this.contatos = [
      {
        id: 1,
        nome: 'João Silva',
        email: 'joao.silva@email.com',
        mensagem: 'Gostaria de saber mais sobre os serviços de cidadania italiana.',
        dataCriacao: '15/03/2024',
        lido: false
      },
      {
        id: 2,
        nome: 'Maria Santos',
        email: 'maria.santos@email.com',
        mensagem: 'Preciso de informações sobre documentação necessária.',
        dataCriacao: '10/02/2024',
        lido: true
      },
      {
        id: 3,
        nome: 'Pedro Oliveira',
        email: 'pedro.oliveira@email.com',
        mensagem: 'Quero agendar uma consulta para avaliação do meu caso.',
        dataCriacao: '25/06/2024',
        lido: false
      },
      {
        id: 4,
        nome: 'Ana Costa',
        email: 'ana.costa@email.com',
        mensagem: 'Dúvida sobre prazos e valores dos serviços.',
        dataCriacao: '05/01/2024',
        lido: true
      }
    ];
  }

  novoContato(): void {
    this.contatoEditando = null;
    this.limparFormulario();
    this.exibirFormulario = true;
  }

  editarContato(contato: Contato): void {
    this.contatoEditando = contato;
    this.formData = {
      nome: contato.nome,
      email: contato.email,
      mensagem: contato.mensagem
    };
    this.exibirFormulario = true;
  }

  salvarContato(): void {
    if (this.contatoEditando) {
      // Editar contato existente
      const index = this.contatos.findIndex(c => c.id === this.contatoEditando!.id);
      if (index !== -1) {
        this.contatos[index] = {
          ...this.contatos[index],
          ...this.formData
        };
      }
    } else {
      // Novo contato
      const novoContato: Contato = {
        id: this.contatos.length + 1,
        nome: this.formData.nome,
        email: this.formData.email,
        mensagem: this.formData.mensagem,
        dataCriacao: new Date().toLocaleDateString('pt-BR'),
        lido: false
      };
      this.contatos.push(novoContato);
    }

    this.exibirFormulario = false;
    this.limparFormulario();
  }

  excluirContato(id: number): void {
    if (confirm('Tem certeza que deseja excluir este contato?')) {
      this.contatos = this.contatos.filter(c => c.id !== id);
    }
  }

  cancelar(): void {
    this.exibirFormulario = false;
    this.limparFormulario();
  }

  limparFormulario(): void {
    this.formData = {
      nome: '',
      email: '',
      mensagem: ''
    };
  }

  getContatosFiltrados(): Contato[] {
    return this.contatos.filter(contato => {
      const nomeMatch = !this.filtroNome || 
        contato.nome.toLowerCase().includes(this.filtroNome.toLowerCase());
      
      return nomeMatch;
    });
  }

  alterarStatusLido(contato: Contato): void {
    contato.lido = !contato.lido;
  }

  limparFiltros(): void {
    this.filtroNome = '';
  }
} 